import isObject from 'lodash/isObject'
import F2Chart from './F2Chart'

/**
 * @param config
 * @param updateLegends
 * @param updateTooltipEl
 * @return {null|F2Chart}
 */
export default (config, updateLegends, updateTooltipEl) => {
  if (!isObject(config) || Object.keys(config).length <= 0) return null

  const chart = new F2Chart(config, updateLegends, updateTooltipEl)

  chart.render()
  return chart
}
